import KoobInputStars from '@koob/ui/src/components/KoobInputStars';
import KoobInputSelect from '@koob/ui/src/components/KoobInputSelect';
import { useTripFilters } from '../../hooks/useTripStoreSelectors';
import { useUpdateTripFilter } from '../../hooks/useUpdateTripFilter';
import { toOptions, type FilterItem } from '../../logic/tripFilterOptions';
import TripFilterMultiSelect from './TripFilterMultiSelect';

interface List {
  items: FilterItem[];
  isLoading: boolean;
}

interface Props {
  t: (key: string) => string;
  categories: List;
  kinds: List;
  styles: List;
  sustainableLevels: List;
}

// Hotel search: stars, category, traveler types, style and sustainable level.
export default function TripFilterHotel({
  t,
  categories,
  kinds,
  styles,
  sustainableLevels,
}: Props) {
  const tripFilters = useTripFilters();
  const updateFilter = useUpdateTripFilter();

  return (
    <>
      <div>
        <KoobInputStars
          rounded="full"
          value={tripFilters?.stars}
          onValueChange={(value: unknown) => updateFilter('stars', value)}
          clearable
        />
      </div>

      <TripFilterMultiSelect
        property="categories"
        placeholder={t('hotel:hotelCategory')}
        items={categories.items}
        loading={categories.isLoading}
      />
      <TripFilterMultiSelect
        property="kinds"
        placeholder={t('hotel:hotelTypology')}
        items={kinds.items}
        loading={kinds.isLoading}
      />
      <TripFilterMultiSelect
        property="styles"
        placeholder={t('hotel:hotelStyle')}
        items={styles.items}
        loading={styles.isLoading}
      />

      <div className="w-48">
        <KoobInputSelect
          rounded="full"
          placeholder={t('hotel:sustainableLevel')}
          loading={sustainableLevels.isLoading}
          options={toOptions(sustainableLevels.items)}
          value={tripFilters?.sustainableLevel?.id ?? ''}
          onValueChange={(id: number | string | null) =>
            updateFilter(
              'sustainableLevel',
              id != null
                ? (sustainableLevels.items.find((item) => item.id === id) ??
                    null)
                : null,
            )
          }
          clearable
        />
      </div>
    </>
  );
}
